//match colors in App.scss
export const metricsColors = {
    cvg: '#F04A4A'
};
export const uiColors = {
    'color_bg-dark': '#333333'
};
